import { render, staticRenderFns } from "./JcomTableBoardMembersAssign.vue?vue&type=template&id=7f9f8fc1"
import script from "./JcomTableBoardMembersAssign.vue?vue&type=script&lang=js"
export * from "./JcomTableBoardMembersAssign.vue?vue&type=script&lang=js"
import style0 from "./JcomTableBoardMembersAssign.vue?vue&type=style&index=0&id=7f9f8fc1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports